<template>
  <!-- 法律咨询 -->
  <div id="question">
    
    <!-- banner -->
    <section><quesbanner /></section>
    
    <section><ad1 /></section>
    
    <section class="w_bg80"><queszxzx /></section>
    
    <section><quesrmzx /></section>
    
    <section  class="w_bg80"><queshftjls /></section>
    <!-- 律师说法 -->
    <section><queslssf /></section>

  </div>
</template>

<script>
import quesbanner from "./child/quesBanner";//banner
import ad1 from "./child/ad1";//banner下第一个律师广告位
import queszxzx from "./child/lawQuestion";//律师最新咨询问题
import quesrmzx from "./child/selectConsult";//热门精选咨询
import queshftjls from "./child/hefeiLawyer";//合肥推荐律师
import queslssf from "./child/lawyerSaid";//律师说法


export default {
  name: "question",

  components: {
    // 私
    quesbanner,
    ad1,
    queszxzx,
    quesrmzx,
    queshftjls,
    queslssf,

  },
};
</script>

<style lang="scss" scope>
#question {
  background-color: #fff;
  .w_bg80 {
    width: 100%;
    background-color: #f8f8f8;
  }
}
</style>